export type Node = {
  id: string;
  title: string;
  description?: string;
  children?: Node[];
  tags?: string[];
  type?: "domain" | "skill" | "tool" | "output";
};

export const tree: Node[] = [
  {
    id: "expertise",
    title: "Core",
    type: "domain",
    children: [
      {
        id: "creative-prod",
        title: "Creative Production & Visual Work",
        type: "skill",
        children: [
          { id: "photoshop", title: "Advanced image editing", type: "tool", description: "15+ years of experience in Adobe Photoshop" },
          { id: "photo-restoration", title: "Photo restoration & reconstruction", type: "tool", description: "Restoration of damaged or old images" },
          { id: "photo-manipulation", title: "High-end photo manipulation & compositing", type: "tool" },
          { id: "color-grading", title: "Professional color grading & correction", type: "tool", description: "For images and video" },
          { id: "branding", title: "Branding & visual identity design", type: "tool", description: "Aligned with project goals" },
          { id: "motion-graphics", title: "Motion graphics", type: "tool", description: "2D and 3D environments" },
          { id: "ai-assets", title: "AI-generated asset refinement", type: "tool", description: "Correction and integration into real workflows" }
        ]
      },
      {
        id: "3d-cad",
        title: "3D, CAD & Asset Creation",
        type: "skill",
        children: [
          { id: "3d-modeling", title: "3D modeling", type: "tool", description: "For both visual and functional purposes" },
          { id: "blender-workflows", title: "Sculpting & hard-surface workflows", type: "tool", description: "In Blender" },
          { id: "fusion360", title: "CAD design", type: "tool", description: "Using Fusion 360" },
          { id: "3d-print-prep", title: "3D print preparation", type: "tool", description: "Optimization, slicing awareness, tolerances" },
          { id: "game-ready", title: "Game-ready asset creation", type: "tool", description: "Low poly, stylized, pixel art, and detailed assets" }
        ]
      },
      {
        id: "audio-multimedia",
        title: "Audio & Multimedia",
        type: "skill",
        children: [
          { id: "sound-design", title: "Sound design & SFX production", type: "tool", description: "For games and video" },
          { id: "audio-editing", title: "Audio editing & mixing", type: "tool", description: "Integration ready" },
          { id: "audio-tools", title: "Tools: Cubase, Reaper", type: "tool" }
        ]
      },
      {
        id: "software-dev",
        title: "Software Development",
        type: "skill",
        children: [
          {
            id: "web-dev",
            title: "Web Development",
            type: "skill",
            children: [
              { id: "frontend", title: "Frontend development", type: "tool", description: "React and Next.js" },
              { id: "backend-baas", title: "Backend & BaaS integration", type: "tool", description: "Firebase and Supabase" },
              { id: "database", title: "Database design & management", type: "tool", description: "Relational (SQL) and Non-relational (NoSQL)" },
              { id: "admin-systems", title: "Admin systems & dashboards", type: "tool", description: "Data-driven applications" },
              { id: "auth-systems", title: "Authentication & user management", type: "tool" },
              { id: "api-integration", title: "API integration & data flow", type: "tool" }
            ]
          },
          {
            id: "app-game",
            title: "App & Game Development",
            type: "skill",
            children: [
              { id: "godot", title: "Game development", type: "tool", description: "Using Godot" },
              { id: "android-studio", title: "Android app development", type: "tool", description: "Using Android Studio" },
              { id: "gameplay-systems", title: "Gameplay mechanics & state handling", type: "tool" },
              { id: "asset-integration", title: "Asset integration", type: "tool", description: "Visual, audio, UI into functional environments" }
            ]
          },
          {
            id: "automation",
            title: "Automation & Systems",
            type: "skill",
            children: [
              { id: "tools-scripts", title: "Small tools & scripts", type: "tool", description: "To automate repetitive workflows" },
              { id: "process-optimization", title: "Process optimization", type: "tool", description: "For creative and technical pipelines" },
              { id: "ssh-env", title: "Environment handling", type: "tool", description: "Using SSH" },
              { id: "deployment-config", title: "Domain & deployment configuration", type: "tool", description: "DNS, hosting, routing" }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "tools-tech",
    title: "Tools & Technologies",
    type: "domain",
    children: [
      {
        id: "creative-media",
        title: "Creative & Media",
        type: "skill",
        children: [
          { id: "adobe-suite", title: "Adobe Suite", type: "tool", description: "Photoshop, Premiere, After Effects, etc." },
          { id: "davinci", title: "DaVinci Resolve", type: "tool" },
          { id: "blender", title: "Blender", type: "tool" }
        ]
      },
      {
        id: "audio-tools-2",
        title: "Audio",
        type: "skill",
        children: [
          { id: "cubase", title: "Cubase", type: "tool" },
          { id: "reaper", title: "Reaper", type: "tool" }
        ]
      },
      {
        id: "3d-cad-tools",
        title: "3D / CAD",
        type: "skill",
        children: [
          { id: "blender-2", title: "Blender", type: "tool" },
          { id: "fusion360-2", title: "Fusion 360", type: "tool" }
        ]
      },
      {
        id: "dev-tools",
        title: "Development",
        type: "skill",
        children: [
          { id: "react", title: "React", type: "tool" },
          { id: "nextjs", title: "Next.js", type: "tool" },
          { id: "firebase", title: "Firebase", type: "tool" },
          { id: "supabase", title: "Supabase", type: "tool" },
          { id: "sql-nosql", title: "SQL / NoSQL databases", type: "tool" }
        ]
      },
      {
        id: "other-tools",
        title: "Other",
        type: "skill",
        children: [
          { id: "godot-2", title: "Godot", type: "tool" },
          { id: "android-studio-2", title: "Android Studio", type: "tool" },
          { id: "git-workflows", title: "Git-based workflows", type: "tool" },
          { id: "ssh-server", title: "SSH / server environments", type: "tool" },
          { id: "dns-deployment", title: "DNS and deployment systems", type: "tool" }
        ]
      }
    ]
  }
];
